import React from "react";
import { Route, Redirect } from "react-router-dom";

export const InternalProtectRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!JSON.parse(localStorage.getItem("SubUserSettings"))) {
        return <Component {...props} />;
      } else {
        return (
          <Redirect
            to={{ pathname: "/files", state: { from: props.location } }}
          />
        );
      }
    }}
  />
);
